// Config from env. Set REACT_APP_* in user/.env (Create React App only exposes REACT_APP_*)

export const TIME_ZONE = process.env.REACT_APP_TIME_ZONE;
export const BACKEND_DOMAIN =
  process.env.REACT_APP_BACKEND_DOMAIN;
export const MERGER_DOMAIN =
  process.env.REACT_APP_MERGER_DOMAIN;

export const S3_BUCKET_KEY =
  process.env.REACT_APP_S3_BUCKET_KEY;
export const REGION_KEY = process.env.REACT_APP_REGION_KEY;
export const S3_ACCESS_KEY = process.env.REACT_APP_S3_ACCESS_KEY;
export const S3_SECRET_KEY = process.env.REACT_APP_S3_SECRET_KEY;
